// Create this new file: src/utils/referralUtils.js

const REFERRAL_STORAGE_KEY = 'g2e_referral_data';
const REFERRAL_EXPIRY_DAYS = 30;

/**
 * Capture referral code from URL and store it with 30-day expiry
 */
export const captureReferralFromURL = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');
    
    if (refCode) {
      const referralData = {
        code: refCode,
        capturedAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + REFERRAL_EXPIRY_DAYS * 24 * 60 * 60 * 1000).toISOString(),
        sourceUrl: window.location.href,
        utmParams: {
          utm_source: urlParams.get('utm_source'),
          utm_medium: urlParams.get('utm_medium'),
          utm_campaign: urlParams.get('utm_campaign'),
        }
      };
      
      localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(referralData));
      console.log('✅ Referral code captured:', refCode);
      
      // Clean URL (optional - removes ref param from URL bar)
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      
      return referralData;
    }
    
    return null;
  } catch (error) {
    console.error('Error capturing referral:', error);
    return null;
  }
};

/**
 * Get stored referral data if it exists and hasn't expired
 */
export const getStoredReferral = () => {
  try {
    const stored = localStorage.getItem(REFERRAL_STORAGE_KEY);
    
    if (!stored) {
      return null;
    }
    
    const referralData = JSON.parse(stored);
    const now = new Date();
    const expiresAt = new Date(referralData.expiresAt);
    
    // Check if expired
    if (now > expiresAt) {
      console.log('⏰ Referral code expired, clearing...');
      clearStoredReferral();
      return null;
    }
    
    return referralData;
  } catch (error) {
    console.error('Error retrieving referral:', error);
    return null;
  }
};

/**
 * Clear stored referral data (called after successful signup)
 */
export const clearStoredReferral = () => {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
    console.log('🧹 Referral data cleared');
  } catch (error) {
    console.error('Error clearing referral:', error);
  }
};

/**
 * Get referral data to send with signup request
 */
export const getReferralDataForSignup = () => {
  const referralData = getStoredReferral();
  
  if (!referralData) {
    return null;
  }
  
  return {
    referred_by_code: referralData.code,
    source_url: referralData.sourceUrl,
    utm_params: referralData.utmParams
  };
};